import styled from 'styled-components'
import FlyoutWithMobileSlideUp from 'components/FlyoutWithMobileSlideUp'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Flyout = styled(FlyoutWithMobileSlideUp)`
  border-radius: 10px;
  overflow: hidden;
`

export const FlyoutContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  width: 320px;
  max-width: 100%;
  background: ${COLORS.white};

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }
`
